import { render } from "./UploadExcel.vue?vue&type=template&id=deba6622"
import script from "./UploadExcel.vue?vue&type=script&lang=js"
export * from "./UploadExcel.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src173764375/src/givergy_presenter_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__